<template>
	<div class="image-select choices">
		<div class="response">
			<div class="answer-wrapper">
				<div v-if="!isAnswered" class="no-answer">
					<span>
						Not Answered
					</span>
				</div>
				<LineGraph v-else-if="isScored" 
					class="line-graph" 
					name="Response"
					:max="getMaxScore"
					:data="getGraphData">
				</LineGraph>
				<ImageSelectPartial
					v-else
					class="fill-table"
					:isSurvey="false"
					:question="question"
					:data="getGraphData"
				></ImageSelectPartial>
			</div>
		</div>
	</div>
</template>

<script>
import QuestionResponse from '.'
import SelectValue from './mixin/select-value'
import SelectOrder from './mixin/select-order'
import ImageSelectPartial from './partialResponse/ImageSelectPartial'
import LoadingButton from '@/module/component/LoadingButton.vue'
import LineGraph from './partialResponse/LineGraph.vue'

export default {
	extends: QuestionResponse,
	mixins: [ SelectValue, SelectOrder ],

	data() {
		return {}
	},

	methods: {
		getScore(val) {
			let idx = null
			this.question.options.forEach((option, index) => {
				if (option.value === val)
					idx = index
			})
			return idx !== null ? this.question.score.default[idx] : 0
		}
	},

	computed: {
		isAnswered() {
			let found = false
			this.oresponse.forEach(res => {
				if (res) found = true
			})
			return found
		},
		limitSelect() {
			if (this.question.hasOwnProperty('limit_select') && this.question.limit_select && 
				this.question.hasOwnProperty('validations') && this.question.validations.filter(v => v.type === 'max_selection').length)
				return this.question.validations.filter(v => v.type === 'max_selection')[0].value
			return 0
		},
		getMaxScore() {
			let max = 0
			let scores = []
			if (this.isScored) {
				Object.keys(this.question.score.default).forEach(k => scores.push(this.question.score.default[k]))

				scores.sort(function(a, b){return a-b}).reverse()
				if (this.limitSelect) {
					for(let i = 0; i < this.limitSelect; i++)
						max += scores[i]
				} else max = scores.reduce(function (acc, s) { return acc + s; }, 0)
			}

			return max
		},
		getGraphData() {
			let data = []
			this.oresponse.forEach((res, index) => {
				if (res && res.length) {
					if (this.isScored) {
						let score = 0
						res.forEach(r => score += this.getScore(r.value))
						data.push({ 'date': this.questionnaireDate(index), 'value': score })
					} else {
						let values = []
						res.forEach(optionRes => values.push(optionRes.value))
						data.push({ 'date': this.questionnaireDate(index), 'value': values })
					}
				}
			})
			return data.reverse()
		}
	},
	
	components: {
		ImageSelectPartial,
		LoadingButton,
		LineGraph
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
